import React, { useEffect, useState } from 'react';
import MiniLogin from 'components/Login/MiniLogin';
import serverConf from 'config/server.config';
import UseBalance from './UseBalance';
import authService from 'services/auth.service';

const Pay = ({ analysisId, payWithCredit }) => {
    const [currentUser, setCurrentUser] = useState(authService.getCurrentUser());

    const updateUser = () => {
        setCurrentUser(authService.getCurrentUser());
    };

    const gclid = localStorage.getItem('gclid') || 'none';
    const reference = `${analysisId}__${gclid}`;

    console.log('[Pay] Generated reference for Stripe:', reference);

    const handlePayment = (baseUrl) => {
        const encodedReference = encodeURIComponent(reference);
        const finalUrl = `${baseUrl}?client_reference_id=${encodedReference}`;
        console.log('[Pay] Redirecting to Stripe with URL:', finalUrl);
        window.location.href = finalUrl;
    };

    return (
        <div className={`flex ${currentUser ? 'flex-col-reverse' : 'flex-col'} items-center justify-center h-full w-full mt-16`}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full items-center justify-center">
                <div className='justify-self-center p-6 bg-blueGray-50 border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 flex flex-col max-w-400-px items-center justify-center'>
                    <h3 className='text-2xl font-bold text-center mb-4'>Pago por uso</h3>
                    <div className='flex flex-row items-center justify-start h-full w-full'>
                        <i className='fas fa-check text-emerald-500 text-lg mr-2'></i>
                        <p className='text-lg text-center'>Válido para una única subasta</p>
                    </div>
                    <div className='flex flex-row items-center justify-start mt-1 h-full w-full'>
                        <i className='fas fa-check text-emerald-500 text-lg mr-2'></i>
                        <p className='text-lg text-center'>Informe en menos de 5 minutos</p>
                    </div>
                    <button 
                        onClick={() => handlePayment(serverConf.single_pay_link)}
                        className='bg-emerald-500 hover:bg-emerald-600 text-white font-bold py-2 px-4 rounded mt-8'
                    >
                        {`Compra 1 crédito por ${parseFloat(serverConf.single_price).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' })}`}
                    </button>
                </div>
                <div className='relative justify-self-center p-6 bg-blueGray-50 border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 flex flex-col max-w-400-px items-center justify-center'>
                    <span className="bg-blue-200 text-base font-medium text-blue-800 text-center py-2 px-4 leading-none rounded-full dark:bg-blue-900 dark:text-blue-200 absolute top-center">
                        <i className='fas fa-tag mr-2'></i>
                        {`Ahorra un ${parseFloat(((1 - (serverConf.bundle_price / (serverConf.single_price * 10))) * 100).toFixed(0))}%`}
                    </span>
                    <h3 className='text-2xl font-bold text-center mb-4'>Compra en pack y ahorra</h3>
                    <div className='flex flex-row items-center justify-start h-full w-full'>
                        <i className='fas fa-check text-emerald-500 text-lg mr-2'></i>
                        <p className='text-lg text-center'>Válido para 10 subastas</p>
                    </div>
                    <div className='flex flex-row items-center justify-start mt-1 h-full w-full'>
                        <i className='fas fa-check text-emerald-500 text-lg mr-2'></i>
                        <p className='text-lg text-center'>Informe en menos de 5 minutos</p>
                    </div>
                    <button 
                        onClick={() => handlePayment(serverConf.bundle_pay_link)}
                        className='bg-emerald-500 hover:bg-emerald-600 text-white font-bold py-2 px-4 rounded mt-8'
                    >
                        {`Compra 10 créditos por ${parseFloat(serverConf.bundle_price).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' })}`}
                    </button>
                </div>
            </div>
            {currentUser ? (
                <div className='w-10/12 mb-16'>
                    <UseBalance payWithCredit={payWithCredit} />
                </div>
            ) : (
                <div className='w-10/12 mt-16'>
                    <MiniLogin title={'Inicia sesión para usar tu saldo'} updateUser={updateUser} />
                </div>
            )}
        </div >
    );
};

export default Pay;